import { Field } from 'formik'
import { clamp, isEmpty } from 'lodash'
import React from 'react'
import { QuantityCounter, type QuantityCounterProps } from 'components/Counter'

interface ProductQuantityCounterFieldProps
  extends Pick<
    QuantityCounterProps,
    'id' | 'minimumOrderQuantity' | 'quantityUnit' | 'isDisabled' | 'textProps'
  > {
  name: string
  availableQuantity: number
}

export const ProductQuantityCounterField: React.FC<
  React.PWC<ProductQuantityCounterFieldProps>
> = ({ id, name, minimumOrderQuantity, availableQuantity, ...rest }) => (
  <Field name={name}>
    {({ field, meta, form: { setFieldValue } }) => (
      <QuantityCounter
        {...field}
        id={id}
        onChange={({ target: { value } }) => {
          const inputQuantity = parseInt(value) || 0
          setFieldValue(field.name, clamp(inputQuantity, 0, availableQuantity))
        }}
        onIncrement={() => {
          setFieldValue(field.name, field.value + 1)
        }}
        onDecrement={() => {
          setFieldValue(field.name, field.value - 1)
        }}
        isIncrementDisabled={field.value >= availableQuantity}
        isDecrementDisabled={field.value <= minimumOrderQuantity}
        minimumOrderQuantity={minimumOrderQuantity}
        isError={meta.touched && !isEmpty(meta.error)}
        {...rest}
      />
    )}
  </Field>
)
